<template>
  <div class="chargeback-info-container">
    <div class="title">{{ $t('message.refuse.klarnaRebutDrawer.chargeInfoTitle') }}</div>
    <div class="item">
      <div class="item-title">{{ $t('message.refuse.klarnaRebutDrawer.chargeInfoDate') }}</div>
      <div class="item-text">{{ data?.chargebackDate || noDataString }}</div>
    </div>
    <div class="item">
      <div class="item-title">{{ $t('message.refuse.klarnaRebutDrawer.chargeInfoDeadline') }}</div>
      <div class="item-text">{{ data?.chargebackDueDate || noDataString }}</div>
    </div>
    <div class="item">
      <div class="item-title">{{ $t('message.refuse.klarnaRebutDrawer.chargeInfoAmount') }}</div>
      <div class="item-text">{{ data?.chargebackAmount || noDataString }}</div>
    </div>
    <div class="item">
      <div class="item-title">{{ $t('message.refuse.klarnaRebutDrawer.chargeInfoReason') }}</div>
      <div class="item-text light">
        <span v-html="displayedReason"></span>
        <button style="margin-left: 8px;color: #1A202C;" v-if="isReasonLong" @click="toggleReason">{{ isExpanded ? $t('message.common.packUp') : $t('message.common.more') }}</button>
      </div>
    </div>
    <div class="item">
      <div class="item-title">{{ $t('message.refuse.klarnaRebutDrawer.chargeInfoMethod') }}</div>
      <div class="item-text">{{ data?.cardType || noDataString  }}</div>
    </div>
  </div>
</template>

<script>
import { noDataString } from '@/const/const.js';
import { RefusalBankStatus } from '@/views/transaction/status/transaction';
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      noDataString,
      isExpanded: false,
    };
  },
  computed: {
    chargebackReason() {
      if (this.data) {
        return this.$t((RefusalBankStatus.find(res => (res.value + '') === '' + this.data.chargebackCode) || RefusalBankStatus[0]).label);
      } else {
        return '';
      }
    },
    isReasonLong() {
      return this.chargebackReason.length > 100;
    },
    displayedReason() {
      if (this.isExpanded || !this.isReasonLong) {
        return this.$t(this.chargebackReason);
      }
      return this.$t(this.chargebackReason).substring(0, 100) + '...';
    },
  },
  methods: {
    toggleReason() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.chargeback-info-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 80vh;
  overflow: hidden;
  overflow-y: auto;
  .title {
    font-family: Open Sans, Open Sans;
    font-weight: bold;
    font-size: 18px;
    color: #667085;
    line-height: 26px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .item {
      .item-title {
        font-family: Open Sans, Open Sans;
        font-weight: 400;
        font-size: 14px;
        color: #667085;
        line-height: 18px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 6px;
      }
      .item-text {
        width: 200px;
        font-family: Open Sans, Open Sans;
        font-weight: 400;
        font-size: 14px;
        color: #1A202C;
        line-height: 18px;
        text-align: left;
        font-style: normal;
        flex-wrap: wrap;
      }
    }
}

.light {
  color: #503DF6 !important;
  button {
    background: none;
    border: none;
    color: #503DF6;
    cursor: pointer;
    padding: 0;
    font-size: 14px;
  }
}
</style>
